import { StaticService } from './../../../services/static.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/app-settings';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MatDialog } from '@angular/material/dialog';

// Un enlace del pie. `short` es la etiqueta que se usa en móvil, donde los
// enlaces van en línea y una etiqueta larga rompe la fila en dos.
export interface FooterLink {
  label: string;
  route: string;
  short?: string;
}

export interface FooterGroup {
  title: string;
  legal?: boolean;
  links: FooterLink[];
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  isLogin: boolean = false;

  // El reclamo sale dos veces en la plantilla (bajo el logo en escritorio y
  // cerrando el pie en móvil), así que el texto vive aquí y no duplicado.
  readonly tagline: string = 'Vive más planes, más cerca';

  // Año del copyright de la barra de cierre en escritorio.
  readonly year: number = new Date().getFullYear();

  // Los grupos son la única fuente de los enlaces: en escritorio son las
  // columnas y en móvil se aplanan en dos filas (primero los de navegación,
  // debajo los legales), así que no hay dos listas que mantener a la par.
  groups: FooterGroup[] = [];

  constructor(private staticService: StaticService, private router: Router, private auth: AuthenticationService,
    private dialog: MatDialog) {
    const usr = this.auth.getProfile();
    if (usr) { this.isLogin = true }
    // this.auth.getUsersMe().subscribe({
    //   next: result => {if(result.email) {this.isLogin=true}},
    //   error: err => this.isLogin = false
    // });

    this.groups = [
      {
        title: 'Citylok',
        links: [
          { label: 'Quiénes somos', route: '/quienes-somos' },
        ]
      },
      {
        title: 'Usuario',
        links: this.isLogin
          ? [{ label: 'Mi cuenta', route: '/profile' }]
          : [{ label: 'Regístrate', route: '/signup' }]
      },
      {
        title: 'Contacto',
        links: [
          { label: 'FAQs', route: '/faqs' },
          { label: 'Formulario de contacto', route: '/contact', short: 'Contacto' },
        ]
      },
      {
        title: 'Legales',
        legal: true,
        links: [
          { label: 'Aviso legal', route: '/legal' },
          { label: 'Términos y condiciones', route: '/terms-conditions', short: 'Términos' },
          { label: 'Privacidad', route: '/privacy' },
          { label: 'Cookies', route: '/cookies' },
        ]
      },
    ];
  }

  // Columnas de escritorio: los grupos de navegación. Los legales no son
  // columna, van en la barra de cierre.
  get menuGroups(): FooterGroup[] {
    return this.groups.filter(group => !group.legal);
  }

  // Filas del pie en móvil.
  get menuLinks(): FooterLink[] {
    return this.flatten(false);
  }

  get legalLinks(): FooterLink[] {
    return this.flatten(true);
  }

  private flatten(legal: boolean): FooterLink[] {
    return this.groups
      .filter(group => !!group.legal === legal)
      .reduce((links, group) => links.concat(group.links), [] as FooterLink[]);
  }

  ngOnInit(): void { }

  redirect(from: string, page: string) {
    if (!this.isLogin) {
      this.staticService.setFrom(from);
    }
    if (page == 'new') {
      this.router.navigate(['/login']);

    } else {
      this.router.navigate([`/${page}`]);
    }
  }

  downloadZIP() {
    const url = AppSettings.MEDIA_URI + '/kit-prensa.zip';
    window.open(url, '_blank');
  }

  openSocialLink(type: string) {
    let url = '';
    if (type == 'twitter') {
      url = 'https://twitter.com/citylok';
    }
    if (type == 'instagram') {
      url = 'https://www.instagram.com/citylokapp/';
    }
    if (type == 'tiktok') {
      url = 'https://www.tiktok.com/@citylokapp';
    }
    if (type == 'youtube') {
      url = 'https://www.youtube.com/@citylokapp';
    }
    if (type == 'facebook') {
      url = 'https://www.facebook.com/Citylokapp';
    }
    window.open(url, '_blank')
  }
}
